import React from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { MdClose } from "react-icons/md";
import classes from "./filters.module.css";

/**
 * Reusable right-side filter drawer shell.
 * The page composes its own filter sections as `children`.
 * Filters apply instantly (each child dispatches on change); this shell
 * only provides the panel chrome and a single "Clear All" action.
 *
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - onClearAll: () => void
 *  - children: filter sections (CheckboxFilterGroup, StatusFilter, DateRangeFilter, ...)
 */
const FilterDrawer = ({ open, onClose, onClearAll, children }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.drawerPaper }}
    >
      <div className={classes.drawerHeader}>
        <span className={classes.drawerTitle}>Filters</span>
        <button
          type="button"
          className={classes.closeBtn}
          onClick={onClose}
          aria-label="Close filters"
        >
          <MdClose />
        </button>
      </div>

      <div className={classes.drawerBody}>{children}</div>

      {onClearAll && (
        <div className={classes.drawerFooter}>
          <Button
            variant="text"
            onClick={onClearAll}
            sx={{ textTransform: "none", color: "var(--tp-text-muted)" }}
          >
            Clear All
          </Button>
        </div>
      )}
    </Drawer>
  );
};

export default FilterDrawer;
